/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyContactModel } from '../../models/client-survey-contact-model';

export interface GetSurveyContactByIdAsync$Plain$Params {

/**
 * surveycontact id filter
 */
  surveyContactId: number;
}

export function getSurveyContactByIdAsync$Plain(http: HttpClient, rootUrl: string, params: GetSurveyContactByIdAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactModel>> {
  const rb = new RequestBuilder(rootUrl, getSurveyContactByIdAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('surveyContactId', params.surveyContactId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyContactModel>;
    })
  );
}

getSurveyContactByIdAsync$Plain.PATH = '/api/SurveyContact/{surveyContactId}';
